module.exports = __webpack_public_path__ + "assets/ff32a9bbe6f74dfa1d119816a54e2ac1.mp3";